export default () => {
  document.addEventListener('mouseenter', (e) => {
    // Check if e.target is an Element
    if (e.target instanceof Element) {
      const target = e.target.closest('[data-nav-menu-hover]');
      if (target) {
        const lazyImages = target.querySelectorAll('[data-src]');
        lazyImages.forEach((el) => {
          const dataSrc = el.getAttribute('data-src');
          el.setAttribute('src', dataSrc);
          el.removeAttribute('data-src');
        });
      }
    }
  });
};
